// src/Redux/heroBannerReduce.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";

// Ensure localStorage is only accessed in the browser
let token = null;
if (typeof window !== "undefined") {
  token = localStorage.getItem("x-access-token");
}

// UPLOAD IMAGE ACTION - MOVED TO REDUCER
export const uploadHeroBannerImage = createAsyncThunk(
  "hero-banner/uploadImage",
  async (formData) => {
    const response = await fetch(
      `${Configuration.BACK_BASEURL}hero-banner/upload`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      },
    );

    if (!response.ok) {
      throw new Error("Échec du téléchargement de l'image");
    }

    return response.json();
  },
);

export const addHeroBanner = createAsyncThunk(
  "brand/addHeroBanner",
  async (payload) => {
    const response = await fetch(`${Configuration.BACK_BASEURL}hero-banner`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });
    return response.json();
  },
);

export const editHeroBanner = createAsyncThunk(
  "brand/editHeroBanner",
  async (payload) => {
    const { id, ...brandData } = payload;

    const response = await fetch(
      `${Configuration.BACK_BASEURL}hero-banner/${id}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(brandData),
      },
    );

    if (!response.ok) {
      throw new Error("Failed to update brand");
    }

    return response.json();
  },
);

export const fetchHeroBanner = createAsyncThunk(
  "brand/fetchHeroBanner",
  async () => {
    const response = await fetch(`${Configuration.BACK_BASEURL}hero-banner`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.json();
  },
);

export const getHeroBannerById = createAsyncThunk(
  "hero-banner/getHeroBannerById",
  async (id) => {
    const response = await fetch(
      `${Configuration.BACK_BASEURL}hero-banner/getHeroBannerById/${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.json();
  },
);

export const toggleHeroBannerStatus = createAsyncThunk(
  "hero-banner/toggleStatus",
  async (id) => {
    const response = await fetch(
      `${Configuration.BACK_BASEURL}hero-banner/toggle-status/${id}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error("Failed to toggle hero-banner status");
    }

    const result = await response.json();
    return { id, isActive: result.isActive };
  },
);

// Slice
const heroBannerSlice = createSlice({
  name: "hero-banner",
  initialState: {
    entities: [],
    loading: false,
    uploadLoading: false,
    uploadError: null,
  },
  reducers: {
    profilUpdated(state, action) {
      fetch(`${Configuration.BACK_BASEURL}brand/updateProfile`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-access-token": token || "",
        },
        body: JSON.stringify(action.payload),
      });
    },
    clearUploadState(state) {
      state.uploadLoading = false;
      state.uploadError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Upload image cases
      .addCase(uploadHeroBannerImage.pending, (state) => {
        state.uploadLoading = true;
        state.uploadError = null;
      })
      .addCase(uploadHeroBannerImage.fulfilled, (state, action) => {
        state.uploadLoading = false;
        state.uploadError = null;
      })
      .addCase(uploadHeroBannerImage.rejected, (state, action) => {
        state.uploadLoading = false;
        state.uploadError = action.error.message;
      })
      // Get by ID cases
      .addCase(getHeroBannerById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getHeroBannerById.fulfilled, (state, action) => {
        state.loading = false;
        state.entities = [...state.entities, action.payload];
      })
      .addCase(getHeroBannerById.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { profilUpdated, clearUploadState } = heroBannerSlice.actions;
export default heroBannerSlice.reducer;
